import React, { Component } from 'react';
import { WHItemInfo } from './WHItemInfo';

export class SOPZone extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        var itemInfo = this.props.itemInfo;
        var getLineStatusFunction = this.props.getLineStatus;
        var doNotPickFunction = this.props.doNotPick;
        var backorderFunction = this.props.backorderItem;
        var pickNowFunction = this.props.pickNow;
        var changeBinFunction = this.props.changeBin;
        var cancelItemFunction = this.props.cancelItem;
        var undoCancelFunction = this.props.undoCancel;
        var undoBackorderFunction = this.props.undoBackorder;
        var additionalInfoOptions = this.props.additionalInfoOptions;
        var editInputField = this.props.editInputField
        var updateGiftCardNum = this.props.updateGiftCardNum;
        var updateSerialNum = this.props.updateSerialNum;
        var canCancel = this.props.canCancel;
        var canBackorder = this.props.canBackorder;
        var canEditQty = this.props.canEditQty;
        var location = this.props.location;
        var multiScanThreshold = this.props.multiScanThreshold;
        var updateQuantityFunction = this.props.updateQuantity;
        var startBinQtyEditFunction = this.props.startBinQtyEdit;
        return (
            <div>
                {
                    this.props.zoneItems.map(function (item, idx) {
                        return (
                            <div key={"z"+idx}>
                                <WHItemInfo
                                    item={item}
                                    itemInfo={itemInfo}
                                    getLineStatus={getLineStatusFunction}
                                    doNotPick={doNotPickFunction}
                                    backorderItem={backorderFunction}
                                    pickNow={pickNowFunction}
                                    changeBin={changeBinFunction}
                                    location={location}
                                    additionalInfoOptions={additionalInfoOptions}
                                    editInputField={editInputField}
                                    updateGiftCardNum={updateGiftCardNum}
                                    updateSerialNum={updateSerialNum}
                                    canBackorder={canBackorder}
                                    canCancel={canCancel}
                                    canEditQty={canEditQty}
                                    cancelItem={cancelItemFunction}
                                    undoCancel={undoCancelFunction}
                                    undoBackorder={undoBackorderFunction}
                                    multiScanThreshold={multiScanThreshold}
                                    updateQuantity={updateQuantityFunction}
                                    startBinQtyEdit={startBinQtyEditFunction}
                                 />
                            </div>
                        )
                    })
                }
            </div>
        );
    }
}
